module.exports = __webpack_public_path__ + "img/01—01—Home Network Overview > Multiple Errors.0ede2321.jpg";